import React from "react";

function arrowBack(props) {
  return (
    <svg
      {...props}
      style={{ stroke: "white", fill: "white", width: "32px" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
    >
      <path
        style={{
          lineHeight: "normal",
          textIndent: "0",
          textAlign: "start",
          textDecorationLine: "none",
          textDecorationStyle: "solid",
          textDecorationColor: "#000",
          textTransform: "none",
          blockProgression: "tb",
          isolation: "auto",
          mixBlendMode: "normal",
        }}
        d="M 34.960938 2.9804688 A 2.0002 2.0002 0 0 0 33.585938 3.5859375 L 13.585938 23.585938 A 2.0002 2.0002 0 0 0 13.585938 26.414062 L 33.585938 46.414062 A 2.0002 2.0002 0 1 0 36.414062 43.585938 L 17.828125 25 L 36.414062 6.4140625 A 2.0002 2.0002 0 0 0 34.960938 2.9804688 z"
        fontWeight="400"
        fontFamily="sans-serif"
        whitespace="normal"
        overflow="visible"
      />
    </svg>
  );
}

export default arrowBack;
